export const CONFIG_ACTION_TYPE = {
	// REDUCER TYPES
	IP_ADDRESS_FETCHING_START: 'IP_ADDRESS_FETCHING_START',
	IP_ADDRESS: 'IP_ADDRESS',
};
